import { render, staticRenderFns } from "./FilterSlideover.vue?vue&type=template&id=1ffb0608"
import script from "./FilterSlideover.vue?vue&type=script&lang=js"
export * from "./FilterSlideover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports